<template>
  <div class="header">
    <header class="header-container">
      <div class="logo" @click="toHome">
        <a><img src="@/assets/img/logo.png" alt="" /></a>
        <span class="name">
          <div class="chinese">校园数字化医疗</div>
          <div>Campus Digital Medicine</div>
        </span>
      </div>
      <div>
        <img src="@/assets/img/icon_my.png" alt="" />
        <span id="components-dropdown-demo-placement" v-if="isLogin">
          <a-dropdown>
            <a class="myserve">{{
              (userInfo && userInfo.userName) || "个人中心"
            }}</a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a class="myserve" @click="toMyServe()">我的预约</a>
              </a-menu-item>
              <a-menu-item>
                <a class="myserve" @click="toMyServe(7)">就诊人管理</a>
              </a-menu-item>
              <a-menu-item>
                <a class="myserve" @click="toMyServe(9)">个人信息</a>
              </a-menu-item>
              <a-menu-item>
                <a class="myserve" @click="changePassword()">修改密码</a>
              </a-menu-item>
              <a-menu-item>
                <a class="myserve" @click="changePhone()">修改手机号</a>
              </a-menu-item>
              <a-menu-item>
                <a class="myserve" @click="toLogout()">退出登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <template v-else>
          <a class="myserve" @click="toLogin">统一认证登录</a>
          <a class="backstage" @click="toAccount">账号登录</a>
        </template>
      </div>
    </header>
    <!--修改密码对话框-->
    <a-modal v-model="isPassword" title="修改密码" :maskClosable="false" centered :confirmLoading="confirmLoading"
      @ok="handleOk" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="旧密码" prop="oldPassword">
          <a-input v-model="form.oldPassword" placeholder="请输入旧密码" />
        </a-form-model-item>
        <a-form-model-item label="新密码" prop="newPassword">
          <a-input v-model="form.newPassword" placeholder="请输入新密码" />
        </a-form-model-item>
        <a-form-model-item label="确认密码" prop="confirmPassword">
          <a-input v-model="form.confirmPassword" placeholder="请输入确认密码" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--修改手机号-->
    <a-modal v-model="isPhone" title="修改手机号" :maskClosable="false" centered :confirmLoading="confirmPhoneLoading"
      @ok="confirmPhone" @cancel="cancelPhone">
      <a-form-model ref="phoneForm" :model="phoneForm" :rules="phoneRules" :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-model-item label="旧手机号" prop="oldPhoneNo">
          <a-input disabled v-model="phoneForm.oldPhoneNo" placeholder="请输入旧手机号" />
        </a-form-model-item>
        <a-form-model-item label="新手机号" prop="newPhoneNo">
          <a-input v-model="phoneForm.newPhoneNo" placeholder="请输入新手机号" />
        </a-form-model-item>
        <a-form-model-item label="验证码" prop="checkCode">
          <a-row :gutter="8">
            <a-col :span="8">
              <a-input v-model="phoneForm.checkCode" :maxLength="6" placeholder="请输入" />
            </a-col>
            <a-col :span="5">
              <a-button :disabled="isStart" @click="getCodeFn">
                获取{{ isStart ? "(" + second + ")" : "" }}
              </a-button>
            </a-col>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { uuid } from "@/utils";
import {
  updatePassword,
  getUserDetail,
  updateUserPhone,
  updatePhoneCode,
} from "@/api/bac";
import { userLogin } from "@/api/login";
import base from "@/assets/base/base.js";
import store from "@/store";
export default {
  name: "Header",
  components: {},
  data() {
    return {
      isPassword: false,
      isPhone: false,
      confirmLoading: false,
      confirmPhoneLoading: false,
      type: null,
      uuid: sessionStorage.getItem("uuid") || "",
      userInfo: {},
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
          {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            message: "必须包含大小写字母和数字的组合，长度在8位以上",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur",
          },
          {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
            message: "必须包含大小写字母和数字的组合，长度在8位以上",
            trigger: "blur",
          },
        ],
      },
      phoneForm: {
        checkCode: "",
        newPhoneNo: "",
        oldPhoneNo: "",
      },
      phoneRules: {
        checkCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        newPhoneNo: [
          {
            required: true,
            message: "请输入新手机号",
            trigger: "blur",
          },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        oldPhoneNo: [
          {
            required: true,
            message: "请输入旧手机号",
            trigger: "blur",
          },
          {
            pattern:
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
      },
      isStart: false,
      second: 60,
    };
  },
  created() {
    // this.uuid = sessionStorage.getItem('uuid') || ''
  },

  computed: {
    ...mapGetters({
      layoutTitle: "layout/lyaoutTitle",
    }),
    isLogin() {
      try {
        this.userInfo =
          sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"));
      } catch (error) { }

      return this.$store.state.login.isLogin;
    },
  },
  watch: {
    uuid: {
      handler(val) {
        if (val) {
          this.userInfo =
            sessionStorage.getItem("userInfo") &&
            JSON.parse(sessionStorage.getItem("userInfo"));
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**退出登录 */
    toLogout() {
      let that = this;
      this.$confirm({
        title: "提示",
        content: "是否确定退出",
        onOk() {
          that.toLogoutFn();
        },
        onCancel() { },
      });
    },
    toLogoutFn() {
      this.delCookie();
      sessionStorage.clear();
      this.uuid = sessionStorage.getItem("uuid") || "";
      window.open("https://xyszyl.zju.edu.cn/medical/pc/#/", "_self");
      location.reload(true);
    },
    changePassword() {
      this.form = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.isPassword = true;
      this.confirmLoading = false;
    },
    changePhone() {
      this.phoneForm = {
        checkCode: "",
        newPhoneNo: "",
        oldPhoneNo: this.userInfo.phone,
      };
      this.isPhone = true;
      this.confirmPhoneLoading = false;
    },

    //获取验证码
    async getCodeFn() {
      if (!base.isPoneAvailable(this.phoneForm.newPhoneNo)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (this.phoneForm.newPhoneNo == this.phoneForm.oldPhoneNo) {
        this.$message.warning("新旧手机号不能相同");
        return;
      }
      let params = {
        phone: this.phoneForm.newPhoneNo,
      };
      const { code, msg } = await updatePhoneCode(params);
      if (code == 200) {
        this.$message.success(msg);
        this.startTime();
      }
    },
    /**倒计时*/
    startTime() {
      this.second = 60;
      this.isStart = true;
      this.setTime = setInterval(() => {
        if (this.second > 1) {
          this.second--;
        } else {
          clearInterval(this.setTime);
          this.isStart = false;
        }
      }, 1 * 1000);
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.changePasswordRequest();
        } else {
          return false;
        }
      });
    },
    confirmPhone() {
      this.$refs.phoneForm.validate((valid) => {
        if (valid) {
          if (this.phoneForm.newPhoneNo == this.phoneForm.oldPhoneNo) {
            this.$message.warning("新旧手机号不能相同");
            return;
          }
          this.confirmPhoneRequest();
        } else {
          return false;
        }
      });
    },
    cancelPhone() {
      this.$refs.phoneForm.resetFields();
      setTimeout(() => {
        this.isPhone = false;
      }, 200);
    },

    handleCancel() {
      this.$refs.ruleForm.resetFields();
      setTimeout(() => {
        this.isPassword = false;
      }, 200);
    },

    async confirmPhoneRequest() {
      this.confirmPhoneLoading = true;
      setTimeout(() => {
        this.confirmPhoneLoading = false;
      }, 1000);
      let params = this.phoneForm;

      const { code, msg } = await updateUserPhone(params);
      if (code == 200) {
        this.$message.success(msg);
        this.isPhone = false;
        //获取用户信息
        this.getUserInfo();
        //通知其他页面更新用户信息
        this.$store.commit("login/changUpdateUserTime", Date.now());
      }
    },

    /**获取用户信息 */
    async getUserInfo() {
      let userId = this.userInfo.userNo;

      const { code, data } = await getUserDetail(userId);
      if (code == 200) {
        sessionStorage.setItem("userInfo", JSON.stringify(data));
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
    },

    async changePasswordRequest() {
      this.confirmLoading = true;
      let params = {
        oldPassword: base.encryptAES(this.form.oldPassword),
        newPassword: base.encryptAES(this.form.newPassword),
        confirmPassword: base.encryptAES(this.form.confirmPassword),
      };
      setTimeout(() => {
        this.confirmLoading = false;
      }, 1000);
      const { code, msg } = await updatePassword(params);

      if (code == 200) {
        this.$message.success(msg);
        this.isPassword = false;
        sessionStorage.clear();
        store.commit("login/changLogin", false);
        this.$router.replace("/login");
      }
    },

    ...mapMutations({
      setLayoutTitle: "layout/setLayoutTitle",
    }),

    delCookie() {
      var keys = document.cookie.match(/[^ =;]+(?==)/g);
      if (keys) {
        for (var i = keys.length; i--;) {
          document.cookie =
            keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); // 清除当前域名下的,例如：m.ratingdog.cn
          document.cookie =
            keys[i] +
            "=0;path=/;domain=" +
            document.domain +
            ";expires=" +
            new Date(0).toUTCString(); // 清除当前域名下的，例如 .m.ratingdog.cn
          document.cookie =
            keys[i] +
            "=0;path=/;domain=zju.edu.cn;expires=" +
            new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .ratingdog.cn
        }
      }
    },

    toMyServe(data) {
      this.$router.push({
        path: "/myRegistration",
        query: {
          queryActived: data,
        },
      });
    },
    toAccount() {
      this.$router.push({ path: "/login" });
    },
    toBackstage() {
      window.open(`https://xyszyl.zju.edu.cn/medical/management/`);
    },
    toHome() {
      this.$router.push("/");
    },
    async toLogin() {
      let uuId = uuid();
      let url = "index"
      // 检查是否有保存的重定向路径
      const redirectUrl = sessionStorage.getItem("redirectUrl");
      if (redirectUrl) {
        url = redirectUrl.split('/')[1]
      }

      window.open(
        `https://zjuam.zju.edu.cn/cas/oauth2.0/authorize?response_type=code&client_id=U2ZEp4RHRJTgzgy5Pq&redirect_uri=https://xyszyl.zju.edu.cn/medical/auth/codeRedirect&state=${uuId}_PC_${url}`,
        "_self"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 1px solid #e3e3e3;

  .banner {
    height: 280px;
    width: 100%;
  }

  // background: url('~@/assets/img/header_bg.png') #003f88;
  .header-container {
    max-width: 1200px;
    margin: 0 auto;
    height: 125px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  a {
    font-size: 16px;
  }

  .myserve {
    color: #333;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    margin-left: 8px;
  }

  .backstage {
    margin-top: 5px;
    padding-left: 28px;
    // display: block;
    color: #333;
  }

  .logo {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      height: 60px;
      width: 60px;
    }

    .name {
      margin-left: 10px;
      display: inline-block;
      vertical-align: bottom;
      font-size: 16px;

      .chinese {
        font-size: 32px;
        font-weight: bold;
        color: #333333;
      }
    }
  }
}

.ant-dropdown-menu {
  padding: 0;
}

// .ant-dropdown-menu-item {
//   /deep/ a {
//     font-size: 18px;
//     text-align: center;

//     &:hover {
//       background: #022c64;
//       color: #fff;
//     }
//   }
// }</style>
